import { create, } from "zustand";
import { type FunctionComponent, type ReactElement, } from "react";
import { persist, } from "zustand/middleware";
import { routes, } from "./routes";
import * as mocked from "./mock";
import { getUrlRoute, } from "./getUrlRoute";
import type { Route, RouteName, StakeRecord, UserScore, } from "@types"; 

// import { connect } from 'wagmi/actions'
// import { config, projectId, } from "../config";
// import { raise, } from "./helpers";
// import { chains, } from "./chains";



import type { WalletProvider, WalletProviderId, ChainId, } from "../types";
import type { GetConnectorsReturnType, GetConnectionsReturnType, } from 'wagmi/actions';




// see jason's xforms
// /home/bren/bracket/stake/react-app/src/components/index.jsx (WE2ETH)
// /home/bren/bracket/stake/react-app/src/components/OpenOrderSummary.jsx

export declare type StakeState = {

	accounts: string[];
	activeChainId: ChainId | null; 
	activeModal: boolean;
	activeStakeModal: boolean;
	activeRoute: Route;
	connectorId: WalletProviderId | null;
	chainId: number | null;
	modalContents: ReactElement | null;
	modalTitle: string;

	inviteCode: null | string;
	inviteCodeApplied: boolean;
	leaderBoard: UserScore[];
	routes: Route[];
	loadedStakes: boolean;
	loadingStakes: boolean;
	overlayReady: boolean;
	stakes: StakeRecord[];
	totalStaked: number;
	validatingCode: boolean;
	walletInitialized: boolean;
	walletProvider: WalletProvider | null;
	
	activateModal: (props:{ component: FunctionComponent; title: string; }) => void;
	closeModal: () => void;
	closeStakeModal: () => void;
	disconnect: () => void;
	setupWallet: ( connectors: GetConnectorsReturnType, connections: GetConnectionsReturnType, ) => Promise<void>;
	getTotalStaked: () => string;
	getLeaderBoard: () => Promise<UserScore[]>;
	getStakes: ( args?: { force?: boolean; }) => Promise<StakeRecord[]>;
	getETH: ( ) => Promise<number>; // get the price of ETH.
	openModal: () => void;
	routeTo: ( name: RouteName, ) => void;
	setAccounts: (props: { accounts: string[]; }) => void;
	setActiveChainId: ( id: ChainId, ) => void;
	setWalletProvider: ({ name, }: { name:WalletProvider, }) => void;
	validateCode: ( code: string, ) => Promise<boolean>;
	setOverlayReady: () => void;
};

export const useStakeStore = create<StakeState>()( ( set, get, ) => ({

	accounts: [],
	activeChainId: null,
	activeModal: false,
	activeRoute: getUrlRoute(),
	activeStakeModal: false,
	connectorId: null,
	chainId: null,
	inviteCode: null,
	inviteCodeApplied: false,
	leaderBoard: [],
	loadedStakes: false,
	loadingStakes: false,
	modalContents: null,
	modalTitle: "untitled",
	overlayReady: false,
	routes: routes.sort((a, b) => a.weight > b.weight ? -1 : a.weight !== b.weight ? 1 : 0 ),
	stakes: [],
	totalStaked: 12323.98,
	validatingCode: false,
	walletProvider: null,
	walletInitialized: false,

	activateModal: ({ component:Component, title }) => {
		set({
			modalContents: <Component />,
			modalTitle: title,
			activeStakeModal: true,
		})
	},
	closeModal: () => set({
		activeModal: false,
	}),
	closeStakeModal: () => set({
		modalContents: null,
		modalTitle: "untitled",
		activeStakeModal: false,
	}),
	disconnect: () => {
		set({activeChainId: null, walletProvider: null });
	},
	getTotalStaked: () => get().totalStaked.toLocaleString('en-US', { style: 'currency', currency: 'USD', }),
	getLeaderBoard: async () => {
		throw new Error("leaderboard fetch is not implemented");
	},
	getStakes: async ({ force = false, } = { }) => {
		const { loadedStakes, loadingStakes, stakes, } = get();
		if( loadedStakes ) return stakes;
		if( loadingStakes ) return [];

		const response = mocked;
		// const response = { stake, }; //(await import('./mock')).default;

		if("stake" in response) {
			if(Array.isArray(response.stake)) {
				
				set({ stakes: response.stake, });
				return get().stakes;
			}
			throw new Error("stake data is not structured correctly");
		}
		throw new Error("stake data does not exist");
	},
	getETH: async ( ) => { throw new Error("StakeStore::getETH not implemented") },
	openModal: () => set({ activeModal: true, }),
	routeTo: ( name: RouteName ) => set( state => {
		const nextRoute = state.routes.find(r => r.name === name);
		if( nextRoute ) {
			const { description, route } = nextRoute;
			window.history.pushState({}, description, route + window.location.search);
			return { activeRoute: nextRoute, }
		}
		throw new Error(`invalid route "${name}"`);
	}),
	setAccounts: ({ accounts, }) => set({ accounts }),
	setActiveChainId: ( id: ChainId, ) => set({ activeChainId: id }),
	setOverlayReady: () => set({ overlayReady: true }),
	setWalletProvider: ({ name, }) => set({ walletProvider: name, }),
	setupWallet: async ( connectors, connections, ) => {
		return;
		// console.log('ATTEMPTING WALLET SETUP');
		// console.log(`connections`, connections);
		// for( const connector of connectors ) {
		// 	const chainId = await connector.getChainId();
		// 	if(chainId === 421614) {
		// 		set({ activeChainId: 421614, walletInitialized: true, });
		// 	}
		// }
	},
	validateCode: async ( code: string, ):Promise<boolean> => {
		set({ validatingCode: true, });

		console.warn("validation is stubbed, setting true if code is ABC123");
		const result = code === "ABC123" ? true : false;

		set(Object.assign(
			{ validatingCode: false, },
			result ? { inviteCode: code, inviteCodeApplied: true, } : { }
		));

		return result;
	},

}));
